module.exports = __webpack_public_path__ + "media/images/favicons_staging/favicon-63841e0936a1e0769705793f2a5223a4.ico";